import { Injectable } from '@angular/core';

import {
  PushPermisoDenegadoError,
  PushPlataformaCliente,
  PushSuscribirDeps,
} from '../../shared/interfaces/push.interface';
import { esAppInstalada } from '../utils/plataforma';
import { suscribirConClave } from '../utils/push-clave';

/**
 * iPhone y iPad (iOS 16.4+). Safari solo expone push con la app agregada a la pantalla
 * de inicio, y el permiso tiene que pedirse en el mismo toque del usuario: nada asíncrono
 * puede ir antes de `Notification.requestPermission()`.
 */
@Injectable({ providedIn: 'root' })
export class PushIosService implements PushPlataformaCliente {
  readonly plataforma = 'ios' as const;

  bloqueo(): 'no-soportado' | 'requiere-instalar' | null {
    if (!esAppInstalada()) {
      return 'requiere-instalar';
    }
    const soportado =
      'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
    return soportado ? null : 'no-soportado';
  }

  async suscribir(deps: PushSuscribirDeps): Promise<PushSubscription> {
    const permiso = await Notification.requestPermission();
    if (permiso !== 'granted') {
      throw new PushPermisoDenegadoError();
    }

    const [registro, clavePublica] = await Promise.all([deps.registro(), deps.clavePublica()]);
    return suscribirConClave(registro, clavePublica);
  }
}
